<template>
    <base-dashboard-view class="shows">
        <div class="shows-header">
            <h1>Shows</h1>
            <base-submit-button
                class="btn add-btn"
                @click="onCreateShow"
            >
                Add Show
            </base-submit-button>
        </div>
         <transition-group
                name="fade"
                mode="out-in"
            >
            <shows-loader
                v-if="! shows"
                key="shows-loader"
                :items="shows"
            >
                An error occured. We couldn't load your shows. Please contact us, or try again later.
            </shows-loader>
            <template v-else>
                <shows-message-box
                    v-if="hasEmptyShows"
                    key="shows-message-box"
                    class="shows-message-box"
                >
                        <template v-slot:image>
                            <svg-vue icon="no-shows" />
                        </template>
                        <template v-slot:content>
                            <h2 class="title">
                                You don’t have any shows yet!
                            </h2>
                            <p class="content">
                                Let’s get you started by adding your first podcast show to Fusebox. It’s very simple.
                            </p>
                            <base-submit-button
                                class="btn"
                                @click="onCreateShow"
                            >
                                Add New Podcast
                            </base-submit-button>
                        </template>
                </shows-message-box>
                <base-listing-handler
                    v-else
                    key="shows-listing"
                    v-slot:default="{
                        filteredItems,
                        layoutType,
                        itemsTotal,
                        filters,
                        sortOptions,
                        sortBy,
                        isReverse,
                        controlsChange,
                    }"
                    :items="shows"
                    :sort-options="sortListOptions"
                    :disable-filters="true"
                    :disable-filters-items-limit="itemsLimit"
                    :initial-filters-config="initialFiltersConfig"
                    :filter-function="showsFilter"
                >
                    <shows-filter-controls
                        v-if="itemsLimit < itemsTotal"
                        :layout="layoutType"
                        :active-filters="filters"
                        :filters-config="filterListOptions"
                        :select-config="sortOptions"
                        :shows-length="itemsTotal"
                        @change="value => controlsChange(value)"
                    />
                    <shows-listing
                        :layout="layoutType"
                        :items="filteredItems"
                        :sort-options="sortOptions"
                        :sort-by="sortBy"
                        :is-reverse="isReverse"
                        class="dashboard-shows"
                        @change="value => controlsChange(value)"
                    />
                </base-listing-handler>
            </template>
        </transition-group>
    </base-dashboard-view>
</template>

<script>
import ShowsMessageBox from '@/components/Shows/ShowsMessageBox';
import ShowsFilterControls from '@/components/Shows/ShowsFilterControls';
import ShowsListing from '@/components/Shows/ShowsListing';
import { mapState, mapActions, mapMutations } from 'vuex';
import { showsFilter } from '@/utils/listFilters';
import ShowsLoader from '@/components/Shows/ShowsLoader.vue';
import { isEmpty } from 'lodash';
import { ACTION } from '@/components/ShowModal/config';

export default {
    components: {
        ShowsFilterControls,
        ShowsMessageBox,
        ShowsListing,
        ShowsLoader,
    },

    data: () => ({
        itemsLimit: 12,
        sortListOptions: [
            {
                label: 'Title',
                listLabel: 'Title',
                value: 'title',
            },
            {
                label: 'Type',
                listLabel: 'Type',
                value: 'isPro',
            },
            {
                label: 'Episodes',
                listLabel: 'Episodes',
                value: 'episodeCount',
            },
        ],
        filterListOptions: [
            {
                type: 'pro',
                label: 'Pro',
                color: 'green',
            },
            {
                type: 'free',
                label: 'Free',
                color: 'black',
            },
        ],
        initialFiltersConfig: {
            condition: 'isPro',
            conditionMetValue: ['pro', 'free'],
            initialValue: ['free'],
        },
    }),

    computed: {
        ...mapState(['shows']),

        /**
         * Returns true if value is empty, else false
         *
         * @returns {boolean} If has shows
         */
        hasEmptyShows() {
            return this.shows ? isEmpty(this.shows) : false;
        },
    },

    methods: {
        ...mapActions('show/modal', {
            openShowModal: 'openModal',
        }),

        ...mapMutations('show/modal', {
            setShowModalAction: 'setAction',
        }),

        showsFilter,

        /**
         * Handles create show action.
         */
        onCreateShow() {
            this.setShowModalAction(ACTION.CREATE);
            this.openShowModal();
        },
    },
};
</script>
